import { AxiosPromise, AxiosResponse } from 'axios';
import { apiService, manageFilters } from '@app/services';
import { IActiveFilter } from '@app/models';

class LaunchPadService {
    readonly apiBase = '/api/directory/applications';

    getAppCatalog(orderBy: string, asc: string, filters?: IActiveFilter[]): AxiosPromise {
        return apiService.get(this.apiBase + '/mycatalog', {
            params: {
                $orderBy: orderBy + ' ' + asc,
                ...(filters ? { $filter: manageFilters(filters) } : {})
            },
            local: true
        })
            .catch((error: AxiosResponse) => Promise.reject(error));
    }

    getApps(): AxiosPromise {
        return apiService.get(`${this.apiBase}/my`, {
            local: true
        })
            .catch((error: AxiosResponse) => Promise.reject(error));
    }

    reportApp(jsonObject: any, handleSuccess: Function, handleError: Function): AxiosPromise {
        return apiService.post('/api/directory/WorkflowCreationRequests/CreateWorkflowFailureRecord',
            jsonObject,
            {
                onSuccess: handleSuccess,
                onError: handleError,
                local: true
            })
            .catch();
    }; 

    deleteApp(appId: string, handleSuccess: Function, handleError: Function): AxiosPromise {
        return apiService.post(`${this.apiBase}(${appId})/DeleteUserWebApp`,
            null,
            {
                onSuccess: handleSuccess,
                onError: handleError,
                local: true
            })
            .catch();
    }; 

    getOwnedWorkflow(appId: string, handleSuccess: Function, handleError: Function): AxiosPromise {
        return apiService.get(`${this.apiBase}(${appId})/GetSingleOwnedWorkflowApplication`,
            {
                onSuccess: handleSuccess,
                onError: handleError,
                local: true
            })
            .catch();
    }; 

    updateAppAttribute(appId: string, jsonObject: any, handleSuccess: Function, handleError: Function): AxiosPromise {
        return apiService.post(`${this.apiBase}(${appId})/UpdateAttribute`,
            jsonObject,
            {
                onSuccess: handleSuccess,
                onError: handleError,
                local: true
            })
            .catch();
    }; 
}

export const launchPadService = new LaunchPadService();
